import { useQuery } from "@tanstack/react-query";
import { usersApi } from "@/lib/api";

const shortId = (id?: string | null) => (id ? `${id.slice(0, 8)}…` : "—");

/** Resolves a user id to a display name (cached), falling back to a short id. */
export function useUser(id?: string) {
  return useQuery({
    queryKey: ["user", id],
    queryFn: () => usersApi.get(id!).then((r) => r.data.data),
    enabled: !!id,
    staleTime: 60_000,
  });
}

/** Inline display name for a user id. */
export function UserName({ id }: { id?: string | null }) {
  const { data } = useUser(id ?? undefined);
  return <>{data?.name || data?.email || shortId(id)}</>;
}
